<form [formGroup]="form" (ngSubmit)="saveData()" class="tw-flex tw-flex-col tw-items-center tw-pt-6">
  <mh-auth-form-header titleKey="forgot_password.title" explainKey="forgot_password.explain"></mh-auth-form-header>

  <div class="tw-mt-[35px] tw-w-full tw-max-w-[417px]">
    <mh-core-lib-text-input
      [formGroup]="form"
      keyControl="email"
      type="email"
      [placeholder]="'forgot_password.email_placeholder' | translate"
      [ariaLabel]="'forgot_password.email_placeholder' | translate"
      autocomplete="email"
      className="mh-auth-input">
    </mh-core-lib-text-input>

    @if (email.invalid && (email.dirty || email.touched)) {
      <p class="tw-mb-0 tw-mt-2 tw-font-rubik tw-text-sm tw-text-red-500">
        @if (email.errors?.required) {
          {{ 'forms.attributes.not_empty' | translate }}
        } @else {
          {{ 'forms.attributes.email' | translate }}
        }
      </p>
    }
  </div>

  <div class="tw-mt-[29px]">
    <mh-core-lib-button
      [isPrimary]="true"
      [isDisabled]="!canSubmit()"
      [isDownloading]="waiting()"
      [text]="'forgot_password.recovery_password' | translate"
      customClass="!tw-w-auto !tw-min-w-[220px] tw-whitespace-nowrap"
      loaderClass="tw-mx-auto"
      textClass="tw-font-rubik"></mh-core-lib-button>
  </div>
</form>

<div class="tw-pt-5 tw-text-center">
  <a class="tw-font-rubik" routerLink="/login">{{ 'forgot_password.go_home' | translate }}</a>
</div>
